import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ToastrService } from 'ngx-toastr';

@Component({
  imports: [NgIf],
  standalone: true,
  selector: 'copy-cell-renderer',
  template: `
    <div class="cell-container" *ngIf="value">
      <span class="cell-text">{{ value }}</span>
      <button class="copy-btn" (click)="copyToClipboard($event)" title="Copy">
        <span>
          <img src="assets/images/clipboard.svg" width="15" height="15" alt="Copy" />
        </span>
      </button>
    </div>
  `,
  styles: [
    `
      .cell-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .cell-text {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .copy-btn {
        background: none;
        border: none;
        cursor: pointer;
        padding: 0;
        margin-left: 8px;
      }
    `,
  ],
})
export class CopyCellRendererComponent implements ICellRendererAngularComp {
  @Input() params!: ICellRendererParams;
  public value?: string;
  constructor(private toastr: ToastrService) {}

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.value = params.value;
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.value = params.value;
    return true;
  }


  copyToClipboard(event: MouseEvent): void {
    event.stopPropagation();
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(this.value).then(() => {
        this.toastr.success($localize`Copiado al portapapeles`);
      }).catch(err => {
        console.error('Clipboard API failed:', err);
        this.fallbackCopyValue();
      });
    } else {
      this.fallbackCopyValue();
    }
  }

  fallbackCopyValue(): void {
    const textArea = document.createElement('textarea');
    textArea.value = this.value;
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand('copy');
      this.toastr.success($localize`Copiado al portapapeles`);
    } catch (err) {
      console.error('Fallback copy failed:', err);
    }

    document.body.removeChild(textArea);
  }
}
